import api from "./api";

/**
 * Servicio de Finanzas - Dashboard completo
 * Gestiona ingresos, egresos, rentabilidad y reportes
 */
export const finanzasService = {
  // ===== MÉTODOS HEREDADOS - Compatibilidad =====
  getIngresos: async (filters = {}) => {
    const response = await api.get("/ingresos", { params: filters });
    return response.data;
  },

  getGastos: async (filters = {}) => {
    const response = await api.get("/gastos", { params: filters });
    return response.data;
  },

  getComisiones: async (filters = {}) => {
    const response = await api.get("/comisiones", { params: filters });
    return response.data;
  },

  createIngreso: async (ingresoData) => {
    const response = await api.post("/ingresos", ingresoData);
    return response.data;
  },

  createGasto: async (gastoData) => {
    const response = await api.post("/gastos", gastoData);
    return response.data;
  },

  // ===== NUEVOS MÉTODOS - DASHBOARD FINANZAS =====

  /**
   * Obtiene resumen ejecutivo de finanzas
   * Incluye: ingresos totales, egresos totales, utilidad neta, margen, rentabilidad
   */
  getResumenEjecutivo: async (
    periodo = "mensual",
    year = new Date().getFullYear(),
    month = null,
    quarter = null,
  ) => {
    try {
      const params = { periodo, year };
      if (month) params.month = month;
      if (quarter) params.quarter = quarter;

      const response = await api.get("/finanzas/resumen-ejecutivo", { params });
      return response.data.data || response.data;
    } catch (error) {
      console.error("[Finanzas] Error resumen ejecutivo:", error);
      throw error;
    }
  },

  /**
   * Obtiene lista detallada de ingresos
   */
  getDetalleIngresos: async (
    periodo = "mensual",
    year = new Date().getFullYear(),
    month = null,
    quarter = null,
  ) => {
    try {
      const params = { periodo, year };
      if (month) params.month = month;
      if (quarter) params.quarter = quarter;

      const response = await api.get("/finanzas/detalle-ingresos", { params });
      return response.data.data || response.data;
    } catch (error) {
      console.error("[Finanzas] Error detalle ingresos:", error);
      throw error;
    }
  },

  /**
   * Obtiene lista detallada de egresos
   */
  getDetalleEgresos: async (
    periodo = "mensual",
    year = new Date().getFullYear(),
    month = null,
    quarter = null,
  ) => {
    try {
      const params = { periodo, year };
      if (month) params.month = month;
      if (quarter) params.quarter = quarter;

      const response = await api.get("/finanzas/detalle-egresos", { params });
      return response.data.data || response.data;
    } catch (error) {
      console.error("[Finanzas] Error detalle egresos:", error);
      throw error;
    }
  },

  /**
   * Obtiene análisis de rentabilidad
   * Incluye: margen bruto, margen neto, ROI, ROAS
   */
  getAnalisisRentabilidad: async (
    periodo = "mensual",
    year = new Date().getFullYear(),
    month = null,
    quarter = null,
  ) => {
    try {
      const params = { periodo, year };
      if (month) params.month = month;
      if (quarter) params.quarter = quarter;

      const response = await api.get("/finanzas/analisis-rentabilidad", {
        params,
      });
      return response.data.data || response.data;
    } catch (error) {
      console.error("[Finanzas] Error análisis rentabilidad:", error);
      throw error;
    }
  },

  /**
   * Obtiene comparativa con período anterior
   */
  getComparativa: async (
    periodo = "mensual",
    year = new Date().getFullYear(),
    month = null,
    quarter = null,
  ) => {
    try {
      const params = { periodo, year };
      if (month) params.month = month;
      if (quarter) params.quarter = quarter;

      const response = await api.get("/finanzas/comparativa", { params });
      return response.data.data || response.data;
    } catch (error) {
      console.error("[Finanzas] Error comparativa:", error);
      throw error;
    }
  },

  /**
   * Método antiguo - compatibilidad
   */
  getResumenFinanciero: async (fechaInicio, fechaFin) => {
    const response = await api.get("/finanzas/resumen", {
      params: { fechaInicio, fechaFin },
    });
    return response.data;
  },
};
